<template>
    <div class="step-dash"
        :style="defineBackground"
         :class="[status, name]">
        <div class="bg-black" v-if="openSessions"></div>
        <div class="step-icon">
            <div class="circle-icon"
                :style="defineCircleBackground"            
                 :class="status">
                <!-- <img :src="img" alt=""> -->
                <ScheduleIcon :status="status" v-if="name == 'schedule'"></ScheduleIcon>
                <GameIcon :status="status" v-if="name == 'game'"></GameIcon>
                <ReportIcon :status="status" v-if="name != 'schedule' && name != 'game'"></ReportIcon>
            </div>
        </div>
        <div class="step-action">
            <div class="action">
                <div class="button-action" @click="actionButton()">
                    <button-default :loaderButton="loaderButton" :name="name" :textButton="textButton" :classButton="status"></button-default>
                </div>
                <sessions-list v-if="openSessions" :sessions="sessions" @closeSessionsList="closeSessionsList()"></sessions-list>
                <p class="actions-desc"
                    :style="defineTextColor"                
                >{{ textDesc }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import ButtonDefault from '../Buttons/ButtonDefault.vue'
import SessionsList from './SessionsList.vue'
import ScheduleIcon from '../Shared/CustomIcons/Dashboard/Steps/Schedule.vue'
import GameIcon from '../Shared/CustomIcons/Dashboard/Steps/Game.vue'
import ReportIcon from '../Shared/CustomIcons/Dashboard/Steps/Report.vue'
import {addAlpha} from '../../helpers/custom.js'
export default {
    components: {
        ButtonDefault,
        SessionsList,
        ScheduleIcon,
        GameIcon,
        ReportIcon
    },
    methods: {
        actionButton(){
            if(this.status == 'finished'){
                return
            }
            if(this.status == 'in progress'){
                this.$router.push('/game')
                return
            }
            if(this.name == 'schedule'){
                this.openSession()
            }
            if(this.name == 'game' && this.status == 'started-game'){
                this.redirectGame()
            }
            if(this.name == 'report' && this.status == 'open'){
                this.$router.push('/middleware-report')
            }
        },
        openSession(){
            let self = this 
            if(self.openSessions == false){
                setTimeout(function(){ 
                    self.openSessions = true
                }, 200);
            }else{
                self.openSessions = false
            } 
        },
        closeSessionsList(){
            this.openSessions = false
        },
        redirectGame(){
            this.$router.push('/match-making')
            // this.$router.push('/chat-initial')
        }
    },  
    props: {
        
        name : {
            type : String,
            required : true
        },
        status : {
            type : String,
            required : true
        },
        textButton: {
            type : String,
            required : true 
        },
        textDesc: {
            type : String,
            required : true
        },
        sessions: {
            type : Array
        },
        loaderButton: {
            type : Boolean
        }
    },
    data(){
        return{
            openSessions : false,
            colors: {}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        // console.log("status => ", this.status)
    },
    computed: {
        img(){
            // console.log(`NAME: ${this.name}-${this.status}.png`)
            return require(`../../assets/${this.name}-${this.status}.png`)
        },
        defineBackground(){
            let background, color
            if(this.status == 'expired' || this.status == 'disabled') background = '#dddede'
            if(this.status == 'dash-open') background = '#f6f6f6'
            if(this.status == 'scheduled') background = '#f5f5f4'
            if( this.status == 'scheduled-expired') background = '#f5f5f4'
            if(this.status == 'finished' || this.status == 'scheduled-game' || this.status == 'started-game' ) background = this.colors.secondary
            color: this.colors.theme == 'dark' ? `#fff` : `#000`

            return{
                background, color
            }
        },
        defineCircleBackground(){
            let background 
            if(this.status == 'expired' || this.status == 'disabled') background = '#f1f1f1'
            if(this.status == 'scheduled' || this.status == 'scheduled-expired') background = '#fff'
            if(this.status == 'finished' || this.status == 'scheduled-game' || this.status == 'started-game') background = addAlpha("#000000", 0.2)
            return{ background }
        },
        defineTextColor(){
            let color 
            if(this.status == 'expired' || this.status == 'disabled') color = '#8d8d8d'
            if(this.status == 'dash-open') color = this.colors.secondary
            if(this.status == 'scheduled' || this.status == 'scheduled-expired') color = this.colors.secondary
            if(this.status == 'finished' || this.status == 'scheduled-game' || this.status == 'started-game') color = '#fff'
           return{ color }
        }
    }
}
</script>
<style lang="scss">
    .bg-black{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        background-color: #2d2d2de0;
        z-index: 10;
    }

    .step-dash{
        width: 100%;
        height: 100%;
        padding: 6%;
        display: flex;
        align-items: center;
        border-bottom: 3px solid rgba(128, 128, 128, 0.157);

        .step-icon{
            width: 50%;
            height: 100%;
            display: flex;
            align-items: center;

            .circle-icon{

                // padding: 40%;
                padding: 18% 10%;
                background-color : white;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;
                position: relative;

                img{
                    height: 55%;
                    position: absolute;
                }
                svg{
                    width: 110px;
                    height: 80px;
                }
            }
        }

        .step-action{

            width: 55%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .action{
                .actions-desc{

                    font-size: 13px;
                    width: 80%;
                    margin: 0 auto;
                    text-align: center;
                    margin-top: 10%;
                    // color: #2F353A;
                    letter-spacing: 0px;
                    font-weight: 800;
                }
            }
        }
    }

    .expired{
        background-color : #777777;

        .step-icon{

            .circle-icon{

                background-color: #717171;
            }
        }
    }

    .finished{

        background-color: #e2e2e2;

        .step-icon{

            .circle-icon{

                background-color: #d7d7d7;
            }
        }

        .step-action{

            .action{

                .actions-desc{

                    color: rgb(59, 59, 59);
                }
            }
        }
    }

    .disabled, .scheduled, .report.open{

        // background-color: #EFEFEF ;

        .step-icon{

            .circle-icon{

                background-color: #d7d7d7;
            }
        }

        .step-action{

            .action{

                .button-action{

                }

                .actions-desc{
                    
                    color: rgb(59, 59, 59);
                }
            }
        }
    }

    .scheduled{
        // background-color: #e7fffd;

        .step-icon{

            .circle-icon{

                background-color: white;
            }
        }
    }

    .scheduled-game{
        background-color: #abfef9;

        .step-icon{

            .circle-icon{

                // background-color: #9ef0ec;
            }
        }
    }

    .dash-open{
        .step-icon{
            .dash-open{
            }
        }
    }

    .expired{
        .step-action{
            .action{
                .actions-desc{
                    color: white;
                }
            }
        }
    }

    .disabled.game{
        background-color: #E2E2E2;
    }

    .finished.schedule{
        background-color: #EFEFEF;
    }

    


    @media only screen and (min-width: 500px){
        .step-dash .step-icon .circle-icon{
            padding: 27%;
        }
    }

    @media only screen and (min-height : 700px) {
        .step-dash .step-icon .circle-icon{
            // padding: 45%;
        }

        .step-dash .step-icon .circle-icon img[data-v-d7e5b92e] {
            height: 60%;
        }
    }

    @media only screen and (min-width: 750px){
        .step-dash{

            justify-content: center;

            .step-icon{
                
                width: 20%;
                // margin-right: 5%;

                .circle-icon{

                    // padding: 40%;
                    padding: 20% 11%;
                }
            }

            .step-action{

                width: 30%;

                .action{

                    .actions-desc{

                        font-size: 11px;
                    }
                }
            }
        }
    }
</style>
